/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diagnosis-history.reducer';

export const DiagnosisHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagnosisHistoryEntity = useAppSelector(state => state.diagnosisHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagnosisHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagnosisHistory.detail.title">DiagnosisHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.id}</dd>
          <dt>
            <span id="snomedConceptId">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.snomedConceptId">Snomed Concept Id</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.snomedConceptId}</dd>
          <dt>
            <span id="snomedConceptText">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.snomedConceptText">Snomed Concept Text</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.snomedConceptText}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagnosisHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagnosisHistoryEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagnosisHistory.medicalHistory">Medical History</Translate>
          </dt>
          <dd>{diagnosisHistoryEntity.medicalHistory ? diagnosisHistoryEntity.medicalHistory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagnosisHistory.icdDiagnosis">Icd Diagnosis</Translate>
          </dt>
          <dd>{diagnosisHistoryEntity.icdDiagnosis ? diagnosisHistoryEntity.icdDiagnosis.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diagnosis-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diagnosis-history/${diagnosisHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagnosisHistoryDetail;
